import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { UserInvitation, ClientLocation } from '../models/clientLocation';
import { ClientService } from '../services/client.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.less']
})
export class CreateUserComponent implements OnInit {
  selectedPanel : number;
  locations : Array<ClientLocation>;
  newUser : UserInvitation = new UserInvitation();
  clientId : number = 1; // TODO: hardcoded for now but will need to wire up for when CRA picks a client.
  constructor(private toast : ToastrService,private location: Router, private activatedRoute: ActivatedRoute,private users: UserService, private auth : AuthService,private clientSrv : ClientService) 
  {
    this.auth.postLoginRedirect = 'users/create/' + this.clientId;
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) =>{
      this.clientId = parseInt(params.get('client'),10);
      this.auth.postLoginRedirect = 'user/create/' + this.clientId;
      if (!localStorage.getItem('STP-JWT')) {
        this.location.navigateByUrl('/auth')
      }

      this.clientSrv.GetClientLocations(this.clientId).subscribe((results : any)=>{
         this.locations = results.map((v) => {return v;});
      });
    });
  }

  update(ev : any){
    console.log(ev);
    this.newUser[ev.name] = ev.value;
  }

  selectPanel(id : number){
    if(this.selectedPanel == id){
      this.selectedPanel = 0;
    }else{
      this.selectedPanel = id;
    }
  }

  setLocation(loc: any){
    this.newUser.properties.push(loc.value);
    console.log(this.newUser);
  }
  createInvitation(){
    this.newUser.clientId = this.clientId;
    this.auth.CreateUserInvite(this.newUser).subscribe((rsp: any) => {
      console.log('PWReset call returned', rsp);
      this.location.navigateByUrl('users/list/'+this.clientId);
      this.toast.success('user saved successfully', '', {timeOut:5000});
    },
      (err: any) => {
        this.toast.error('error inviting user');
        if(err.status == 401){
          this.location.navigateByUrl('auth');
        }
        console.log(err);
      });
  }
}
